export default "__VITE_ASSET__DEtfDYY9__"